import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';

import ColumnPreviewTable from 'components/FieldColumns/ColumnPreviewTable';
import {
  FieldColumnPicker,
  buildHierarchyPath,
} from 'components/FieldColumns/FieldColumnPicker';

import './PreviewTablePicker.css';

/**
 * Preview Table Picker Component
 * Shows a trigger button that opens a modal for column configuration
 */
export class PreviewTablePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
    };
  }

  handleOpenModal = function() {
    if (this.props.disabled) return;
    this.setState({ modalOpen: true });
  }.bind(this);

  handleCloseModal = function() {
    this.setState({ modalOpen: false });
  }.bind(this);

  handleApply = function(fields) {
    this.props.onSelectedFieldsChange(fields);
    this.setState({ modalOpen: false });
  }.bind(this);

  render() {
    var selectedFields = this.props.selectedFields;
    var availableFields = this.props.availableFields;
    var allFields = this.props.allFields;
    var isRecordListView = this.props.isRecordListView;
    var recordsFieldUniquenessIdentifier = this.props.recordsFieldUniquenessIdentifier;
    var recordFieldTitle = this.props.recordFieldTitle;
    var disabled = this.props.disabled;
    var error = this.props.error;
    var t = this.props.t;

    var modalOpen = this.state.modalOpen;

    var hasColumns = selectedFields && selectedFields.length > 0;

    // Compute selected fields with hierarchy paths for inline preview
    var selectedFieldsWithPaths = hasColumns ? selectedFields.map(function(field) {
      if (!field.hierarchyPath && field.parent && availableFields) {
        return Object.assign({}, field, {
          hierarchyPath: buildHierarchyPath(field, availableFields)
        });
      }
      return field;
    }) : [];

    // Column count label for footer
    var columnCountLabel = hasColumns
      ? selectedFields.length + ' ' + (selectedFields.length === 1
        ? t('settings:columnSingular')
        : t('settings:columnPlural'))
      : '';

    return (
      <div className={classnames('preview-table-picker-wrapper', {
        'preview-table-picker-wrapper--disabled': disabled,
      })}>
        <div className="preview-table-inline-container">
          <div className="preview-table-inline-header">
            <button
              type="button"
              className="preview-table-inline-edit"
              onClick={this.handleOpenModal}
              disabled={disabled}
            >
              <span className="material-symbols-outlined">
                {hasColumns ? 'edit_note' : 'add'}
              </span>
              {hasColumns ? t('settings:editColumns') : t('settings:addColumns')}
            </button>
            {hasColumns && (
              <span className="preview-table-inline-count">
                {columnCountLabel}
              </span>
            )}
          </div>
          <div className="column-picker-preview-wrapper">
            <ColumnPreviewTable columns={selectedFieldsWithPaths} t={t} />
          </div>
        </div>

        {error && (
          <div className="preview-table-error" role="alert">
            {error}
          </div>
        )}

        {modalOpen && (
          <FieldColumnPicker
            selectedFields={selectedFields}
            availableFields={availableFields}
            allFields={allFields}
            isRecordListView={isRecordListView}
            recordsFieldUniquenessIdentifier={recordsFieldUniquenessIdentifier}
            recordFieldTitle={recordFieldTitle}
            onApply={this.handleApply}
            onClose={this.handleCloseModal}
            t={t}
          />
        )}
      </div>
    );
  }
}

PreviewTablePicker.propTypes = {
  selectedFields: PropTypes.array.isRequired,
  availableFields: PropTypes.array.isRequired,
  allFields: PropTypes.array,
  onSelectedFieldsChange: PropTypes.func.isRequired,
  isRecordListView: PropTypes.bool,
  recordsFieldUniquenessIdentifier: PropTypes.string,
  recordFieldTitle: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  t: PropTypes.func.isRequired,
};

PreviewTablePicker.defaultProps = {
  selectedFields: [],
  availableFields: [],
  allFields: [],
  isRecordListView: false,
  recordsFieldUniquenessIdentifier: '',
};

export default withTranslation()(PreviewTablePicker);
